var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var hover = _ref.hover;
        return [_c('v-list-item', _vm._g({}, _vm.hasClickListener ? {
          click: function click() {
            return _vm.$emit('click');
          }
        } : {}), [_c('v-list-item-icon', [_c('v-icon', {
          staticClass: "ml-5 mr-n4"
        }, [_vm._v("mdi-share")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm.hasOpenDetailListener ? _c('a', {
          attrs: {
            "color": _vm.item.expirationColor
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.emitOpenDetail.apply(null, arguments);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.item.expirationReadable) + " ")]) : _c('span', {
          style: {
            color: _vm.item.expirationColor
          }
        }, [_vm._v(_vm._s(_vm.item.expirationReadable))])]), _vm.item.refs && _vm.item.refs.length ? _c('v-list-item-subtitle', _vm._l(_vm.item.refs, function (refs) {
          var _vm$RefTypeMap$get;

          return _c('span', {
            key: refs.refId + refs.refType,
            staticClass: "mr-1",
            attrs: {
              "x-small": ""
            }
          }, [_c('v-icon', {
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(" " + _vm._s(((_vm$RefTypeMap$get = _vm.RefTypeMap.get(refs.refType)) === null || _vm$RefTypeMap$get === void 0 ? void 0 : _vm$RefTypeMap$get.icon) || "") + " ")])], 1);
        }), 0) : _vm._e()], 1), _vm.confirmable ? _c('v-list-item-action', {
          staticClass: "mx-0 px-0"
        }, [_c('tooltip', {
          attrs: {
            "text": _vm.$t('project.ticket.actions.copyLink')
          }
        }, [_c('v-flex', [hover ? _c('v-btn', {
          attrs: {
            "text": "",
            "color": "success",
            "elevation": "0",
            "small": ""
          },
          on: {
            "click": _vm.copyLinkToClipboard
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("components.CopyClipboardText.copy")) + " "), _c('v-icon', {
          staticClass: "pl-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v(" mdi-content-copy ")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }